//This file does not have 100% code coverage.
// TODO: add coverage for the "istanbul ignore next" lines

var getTarget = function getTarget(target) {
  if (target === '') {
    /* istanbul ignore next */
    return {};
  }

  // @see {@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#Security_and_privacy_concerns}
  if (target === '_blank') {
    /* istanbul ignore next */
    return {
      target: target,
      rel: 'noopener noreferrer'
    };
  }
  return {
    target: target
  };
};

export { getTarget };
n